import React from 'react';
import './OptOut.css';
import SideBar from './SideBar/SideBar';
import { Outlet } from 'react-router-dom';

export default function OptOut(){
    return (
        <div className="opt-out--container">
            <SideBar />
            <Outlet />
        </div>
    );
}